<template>
  <div class="table-widget">
    <b-table
      :style="cssVars"
      :data="items.data"
      :bordered="configs.parameters['Borders']"
      :narrowed="true"
      :hoverable="true"
      :row-class="(row, index) => index % 2 === 1 && 'stripe'"
    >
      <template slot-scope="props">
        <b-table-column
          v-for="(value, key) in items.columns"
          :key="key"
          :field="value.field"
          :label="$t(value.label)"
          :class="value.class"
          :sortable="value.sortable"
        >
          <div>
            <p v-html="$lodash.get(props.row, value.field)"></p>
          </div>
        </b-table-column>

        <b-table-column
          v-if="configs.type === 'table' && configs.parameters['Modify'] !== 'off' && configs.parameters['Modify'] !== undefined"
          class="column-input"
          :field="'modify'"
          :label="configs.parameters['Column key']"
        >
          <b-input
            :placeholder="$lodash.get(props.row, configs.parameters['Column key'])"
            :id="$lodash.get(props.row, 'id')"
            :v-model="$lodash.get(props.row, 'id')"
            @change.native="onInputChange"
          >
          </b-input>
        </b-table-column>

        <b-table-column
          v-if="configs.type === 'events_list' && configs.parameters['Acknowledge'] !== 'off'"
          class="column-checkbox"
        >
          <b-button @click="openAcknowladgeModal($lodash.get(props.row, 'id'))" class="button-acknowledge" outlined>
            <span class="text">{{ $t('button.acknowledge') }}</span>
          </b-button>
        </b-table-column>
      </template>
      <template slot="empty">
        <div class="content has-text-grey has-text-centered">
          <p>{{ $t('lists.empty') }}</p>
        </div>
      </template>
    </b-table>

    <b-modal
      :active.sync="isShowAcknowledgeModal"
      has-modal-card
      trap-focus
      @close="closeAcknowladgeModal('leave')"
      aria-role="dialog"
      aria-modal
      class="table-widget-modal"
    >
      <div class="modal-card">
        <section class="modal-card-body">
          <h1 class="field is-horizontal">{{ $t('dashboards.acknowledgeTheEvent') }}</h1>
          <b-field horizontal>
            <template #label>
              <b-tooltip :label="$t('dashboards.comment')" type="is-dark" multilined>
                {{ $t('dashboards.comment') }}
              </b-tooltip>
            </template>
            <b-input type="textarea" v-model="comment" id="comment" name="comment" class="comment" />
          </b-field>

          <div class="field is-horizontal">
            <div class="field-label">
              <div class="reset">
                <edit-button :editOptions="['reset']" :is-gray="true" @click="closeAcknowladgeModal('reset')">
                  <template>
                    <span class="text">{{ this.$t('button.reset') }}</span>
                  </template>
                </edit-button>
              </div>
            </div>
            <div class="field-body">
              <div>
                <edit-button :editOptions="['reject']" :danger="true" @click="closeAcknowladgeModal('reject')">
                  <template>
                    <span class="text">{{ this.$t('button.reject') }}</span>
                  </template>
                </edit-button>
              </div>
              <div class="spacer"></div>
              <div>
                <edit-button :editOptions="['confirm']" @click="closeAcknowladgeModal('confirm')">
                  <template>
                    <span class="text">{{ this.$t('button.confirm') }}</span>
                  </template>
                </edit-button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </b-modal>
  </div>
</template>
<script>
import EditButton from '@/components/EditButton'
export default {
  name: 'DashboardTable',
  components: {
    EditButton
  },
  props: {
    dashboardId: {
      type: String
    },
    items: {
      type: Object,
      default() {
        return {}
      }
    },
    configs: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      checkboxPosition: 'left',
      active: false,
      isShowAcknowledgeModal: false,
      comment: '',
      selected: [],
      acknowledId: ''
    }
  },
  computed: {
    cssVars() {
      return {
        '--stripe-background-color': this.configs.parameters['Stripes color']
      }
    }
  },
  methods: {
    openAcknowladgeModal(id) {
      this.isShowAcknowledgeModal = true
      this.acknowledId = id
    },
    closeAcknowladgeModal(buttonName) {
      this.isShowAcknowledgeModal = false
      if (buttonName == 'leave') {
        this.comment = ''
        return
      }
      const body = {
        event_id: this.acknowledId,
        dashboard_id: this.dashboardId,
        element_id: this.configs.id,
        comment: this.comment,
        button: buttonName
      }
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/dashboard/acknowledge`
      return fetch(url, {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(body)
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(data => {
          this.configs = data.config
          this.items = data.ui_element_data
          this.$forceUpdate()
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
        .finally(() => {
          this.comment = ''
          this.$emit('update')
        })
    },
    onInputChange(event) {
      const body = {
        event_id: event.target.id,
        key: this.configs.parameters['Column key'],
        value: event.target.value
      }
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/dashboard/modify`
      return fetch(url, {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(body)
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    }
  }
}
</script>

<style lang="scss">
.table-widget {
  width: 100%;
  height: 100%;
  overflow: scroll;
  img {
    max-width: 300px;
  }
  .table-widget-modal {
    .modal-card {
      h1 {
        font-size: large;
        font-weight: 900;
      }
      .field-label {
        flex-grow: 1;
        .reset {
          text-align: left;
        }
      }
      .field-body {
        flex-grow: 2;
      }
      .spacer {
        flex-grow: 2;
        margin: 0.5rem;
      }
      .comment {
        width: 100%;
      }
      .upload.control {
        width: 100%;
        .upload-draggable {
          width: 100%;
        }
      }
    }
  }
  .b-table {
    .table.is-hoverable tbody tr:not(.is-selected):hover {
      background-color: #efefef;
    }
    .stripe {
      background-color: var(--stripe-background-color);
    }
    th.checkbox-cell .checkbox {
      display: none;
    }
    td {
      user-select: text;
      vertical-align: middle;
      .checkbox {
        display: flex;
      }
    }
    .column-checkbox {
      width: 2.5rem;
    }
    .column-input {
      width: 5rem;
    }

    .button-acknowledge {
      color: #3273dc;
      background-color: #fff;
      border: 1px solid #3273dc;
      padding-top: 0;
      padding-bottom: 0;
      font-size: unset;
      line-height: unset;
      height: unset;
      &:hover {
        color: #fff;
        background-color: #3273dc;
        border: 1px solid #3273dc;
      }
    }
  }
}
</style>
